<template>
  <div class="container-fluid">
    <div class="btn-toolbar" role="toolbar">
      <button @click="save" id="comsave" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
    </div>
    <div class="row mt-3">
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Firmen-UI-Verzeichnis:</label>
              <input id="firmuidir" v-model="config['html.resource.firmui']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Katalog-Verzeichnis:</label>
              <input id="catalogsdir" v-model="config['if.proxy.catalog.path']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Auftragsdateiparameter-Verzeichnis:</label>
              <input id="submitdir" v-model="config['if.proxy.files.submit']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>PostgreSQL-Backup:</label>
              <input v-model="config['if.proxy.pg.pgdump']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Backup-Verzeichnis:</label>
              <input v-model="config['if.proxy.pg.temp']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Office Templates:</label>
              <input v-model="config['if.proxy.print.templates']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Max. Bestellhistorie:</label>
              <input v-model="config['archiv.ordermonth']" type="text" class="form-control"/>&nbsp;Monate
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>bShop URL:</label>
              <input v-model="config['bshop.url']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>bShop API Key:</label>
              <input v-model="config['bshop.apikey']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>Connector-Lizenz-Key:</label>
              <input id="lickey" v-model="config['proxy.connector.lickey']" type="text" class="form-control"/>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-check">
              <input v-model="config['if.proxy.prices.checklocal']" true-value="1" false-value="0" type="checkbox" class="form-check-input" id="priceCheckLocal"/>
              <label for="priceCheckLocal">Preisüberprüfung:</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-check">
              <input v-model="config['if.proxy.warehousedeltareorder']" type="checkbox" true-value="1" false-value="0" class="form-check-input" id="warehouseDelta"/>
              <label for="warehouseDelta">Lagerkorrektur mit Nachlieferterminen:</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <label>bShop Kundenpasswort (Legacy &lt; 1.9.6):</label>
              <select v-model="config['proxy.bshop.password.mode']" class="form-control">
                <option value="0">Zufallspasswort</option>
                <option value="1">PLZ</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'

export default {
  name: 'CommonConfig',
  data() {
    return {
      needs: ["if.proxy.print.templates","html.resource.firmui","bshop.url","bshop.apikey","proxy.cron.article","if.reports.chrome.path","proxy.connector.lickey","if.proxy.catalog.path","if.reports.root","proxy.bshop.password.mode","if.proxy.dashboard.root","if.proxy.files.submit","if.proxy.warehousedeltareorder","if.proxy.prices.checklocal","if.proxy.pg.temp","if.proxy.pg.pgdump","archiv.ordermonth"],
      config: {}
    }
  },
  created: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
    })
  },
  methods: {
    boolVal: function(val) {
      if (val) {
        var test = String(val);
        return test.startsWith('1') || test.startsWith('1');
      }
      return false;
    },
    save: function() {
      var self = this;
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'Allgemein',variant: 'success'});
      })
    }
  }
}
</script>
